import React from 'react';
import styles from '../Operations.module.css';

interface ARCTComponent extends React.FC {
  title?: string;
}

/**
 * SCANRATE - Scan Rate
 * KPI information component
 */
const ARCT: ARCTComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Scan Rate measures the percent of total Ace Rewards transactions to your total transactions.<br/><br/>
        This includes any transaction where an Ace Rewards number is associated (including house accounts).
        This metric is calculated for in-store transactions only as a rolling 12-month metric.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
       Asking for the customers phone number, scanning the Ace Hardware mobile app or Ace Rewards key fob on every transaction delivers improved customer targeting, and in turn stronger response rates and incremental sales for your store.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        Pinnacle &gt;= 70%
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        <ul>
          <li>Reinforce with all associates the importance of capturing Ace Rewards information on every transaction. Cashiers should consistently ask for the customer’s phone number, key fob, or Ace Rewards ID at checkout.</li>
          <li>When an Ace Rewards number is not attached to a transaction, even loyal customers can fall into an inactive status—meaning they will no longer receive communications from us.</li>
          <li>To ensure your marketing dollars are effective, it is essential that an Ace Rewards number is collected on all transactions. This allows for highly personalized promotions to be developed and delivered to the right customers at the right time.</li>
        </ul>
      </div>
    </div>
  );
};

ARCT.title = 'Scan Rate - Ace Rewards';
export default ARCT;

